"use client";

import { motion } from "framer-motion";
import { useTranslation } from "next-i18next";
import { IoMdAlert } from "react-icons/io";
export function AnimatedNoContent() {
  const {
    t
  } = useTranslation();
  return <div className="flex flex-col items-center justify-center min-h-[400px] p-8 text-center bg-gradient-to-b from-neutral-100 to-white dark:from-neutral-900 dark:to-neutral-800 rounded-3xl shadow-md" data-sentry-component="AnimatedNoContent" data-sentry-source-file="no-content.tsx">
      <motion.div className="text-neutral-300 dark:text-neutral-400 mb-4" initial={{
      scale: 0.8,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      delay: 0.1,
      duration: 0.4,
      ease: "easeOut"
    }} data-sentry-element="unknown" data-sentry-source-file="no-content.tsx">
        <IoMdAlert className="text-6xl" data-sentry-element="IoMdAlert" data-sentry-source-file="no-content.tsx" />
      </motion.div>
      
      <motion.h2 className="text-3xl font-bold text-neutral-600 dark:text-white mb-4" initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.2,
      duration: 0.5,
      ease: "easeOut"
    }} data-sentry-element="unknown" data-sentry-source-file="no-content.tsx">
        {t("common:text-no-content-title")}
      </motion.h2>

      <motion.p className="text-muted-foreground max-w-md mb-6" initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.3,
      duration: 0.5,
      ease: "easeOut"
    }} data-sentry-element="unknown" data-sentry-source-file="no-content.tsx">
        {t("common:text-no-content-description")}
      </motion.p>

      <motion.div initial={{
      scale: 0.9,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      delay: 0.4,
      duration: 0.4,
      ease: "easeOut"
    }} data-sentry-element="unknown" data-sentry-source-file="no-content.tsx">
      </motion.div>
    </div>;
}